/* Contexte du modele sur la fiche (01/11/2026, audit des 30 profils, probleme 10).
   Une piece partagee par plusieurs modeles s'affiche cote serveur avec son modele principal
   (« Vis ... pour Lotus Jubilee 15 », repere 8 du schema 8). Ouverte depuis la M2ST, elle doit
   parler de la M2ST : titre, fil d'Ariane et demande de prix (schema et repere de CE modele).
   Modele de contexte : parametre ?modele= (liens des schemas et des resultats), sinon
   « Mon appareil ». Seulement s'il figure dans la compatibilite de la piece : jamais un
   modele que la donnee ne prouve pas. Le titre de la page (SEO) et l'URL canonique ne
   changent pas. Donnee : #k-pdp-compat-data (models, quote_occurrences). */
document.addEventListener('DOMContentLoaded', function () {
  'use strict';
  var donnees = document.getElementById('k-pdp-compat-data');
  var titre = document.querySelector('[data-k-contexte-ssr]');
  if (!donnees || !titre) return;
  var data;
  try { data = JSON.parse(donnees.textContent); } catch (e) { return; }
  var modeles = Array.isArray(data.models) ? data.models : [];
  var occurrences = Array.isArray(data.quote_occurrences) ? data.quote_occurrences : [];
  var ssr = titre.getAttribute('data-k-contexte-ssr') || '';
  var ssrLabel = titre.getAttribute('data-k-contexte-ssr-label') || '';
  if (!ssr || !ssrLabel || modeles.length < 2) return;

  function modele(handle) {
    for (var i = 0; i < modeles.length; i++) if (modeles[i] && modeles[i].handle === handle) return modeles[i];
    return null;
  }
  var demande = '';
  try { demande = new URLSearchParams(window.location.search).get('modele') || ''; } catch (e) { demande = ''; }
  var memoire = window.KrepiteDeviceMemory && window.KrepiteDeviceMemory.get ? window.KrepiteDeviceMemory.get() : null;
  var choisi = modele(demande) || (memoire ? modele(memoire.model_handle) : null);
  if (!choisi || choisi.handle === ssr) return;

  var occ = null;
  for (var j = 0; j < occurrences.length; j++) if (occurrences[j] && occurrences[j].model_handle === choisi.handle) { occ = occurrences[j]; break; }

  // Titre visible : « ... pour Lotus Jubilee 15 » -> « ... pour Lotus M2ST ».
  if (titre.textContent.indexOf(ssrLabel) !== -1) titre.textContent = titre.textContent.replace(ssrLabel, choisi.label);

  // Fil d'Ariane : l'etape du modele.
  var etape = document.querySelector('.k-breadcrumbs a[href$="/collections/model-' + ssr + '"]');
  if (etape && choisi.url) {
    etape.setAttribute('href', choisi.url);
    var marque = ssrLabel.split(' ')[0];
    etape.textContent = choisi.label.indexOf(marque + ' ') === 0 ? choisi.label.slice(marque.length + 1) : choisi.label;
  }

  // Demande de prix : modele, schema et repere de CE modele.
  var recap = document.querySelector('[data-k-quote-recap-modele]');
  if (recap) recap.textContent = ' · pour ' + choisi.label;
  document.querySelectorAll('input[name="contact[model]"]').forEach(function (champ) { champ.value = choisi.label; });
  if (occ) {
    document.querySelectorAll('input[name="contact[schema]"]').forEach(function (champ) { champ.value = occ.schema_number != null ? String(occ.schema_number) : ''; });
    document.querySelectorAll('input[name="contact[position]"]').forEach(function (champ) { champ.value = occ.position_label || ''; });
  }
  document.documentElement.setAttribute('data-k-contexte-modele', choisi.handle);
});
